import { useState, useEffect, useContext, JSX } from 'react';

import PracticeReserveSituationLineBatchAttend from './attendBadge/PracticeReserveSituationLineBatchAttend';
import PracticeReserveSituationLineBatchNew from './newBadge/PracticeReserveSituationLineBatchNew';


// シチュエーション各行で表示するバッチ
function PracticeReserveSituationLineBatch(props: any) {

  const info = props.info;

  return (
    <>
    {info &&
      <>
        {/* new */}
        <PracticeReserveSituationLineBatchNew
          info={info}
        />
        {/* 参加済み */}
        <PracticeReserveSituationLineBatchAttend
          info={info}
        />
      </>
    }
    </>
  );
}
  
export default PracticeReserveSituationLineBatch;